import { Button } from '@farol-ds/react'
import { SocialSignInButton } from '@jusbrasil-web/shared-social-sign-in'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useRef, useState } from 'react'

import { FORCED_GOOGLE_EVENTS, JUSID_PLATFORM_WEB_AUTH } from '../../constants'
import { useFireOnce } from '../../hooks/useFireOnce'
import { ERROR_MESSAGES } from '../../utils/errorMessages'
import { type AuthPageEventData, buildUserAccountEventData } from '../../utils/event-data'
import { LoginCard } from '../login-card'
import styles from './google-sign-in.module.scss'

export interface GoogleSignInProps {
  eventData: AuthPageEventData
  email: string
  nextUrl?: string
  onUseAnotherAccount: () => void
  onCloseClick?: () => void
}

export function GoogleSignIn({
  eventData,
  email,
  nextUrl,
  onUseAnotherAccount,
  onCloseClick,
}: GoogleSignInProps) {
  const [error, setError] = useState<string | undefined>()

  const resolved = {
    ...eventData,
    email,
    fromComponent: eventData.fromComponent ?? 'ForcedGoogleSignIn',
  }
  const metricsData = useRef(buildUserAccountEventData(resolved)).current

  useFireOnce(() => sendMetrics(FORCED_GOOGLE_EVENTS.SCREEN_SEEN, null, metricsData))

  const handleUseAnotherAccount = () => {
    sendMetrics(FORCED_GOOGLE_EVENTS.USE_ANOTHER_ACCOUNT, null, metricsData)
    onUseAnotherAccount()
  }

  const handleError = () => {
    setError(ERROR_MESSAGES.generic.default)
    sendMetrics(FORCED_GOOGLE_EVENTS.ERROR, null, metricsData)
  }

  const header = {
    title: 'Bem-vindo(a) de volta!',
    subtitle: { content: 'Acesse novamente com o Google.' },
    ...(error && {
      errorMessage: {
        title: error,
      },
    }),
  }

  return (
    <LoginCard header={header} onCloseClick={onCloseClick}>
      <SocialSignInButton
        appId={resolved.appId ?? JUSID_PLATFORM_WEB_AUTH}
        featureCode={resolved.featureCode ?? ''}
        fromComponent={resolved.fromComponent}
        kind="primary"
        minHeight={48}
        nextUrl={nextUrl ?? ''}
        provider="google"
        onError={handleError}
      >
        Continuar com Google
      </SocialSignInButton>

      <div className={styles.divider}>
        <span className={styles.dividerText}>ou</span>
      </div>

      <div className={styles.secondary}>
        <Button kind="plain" onClick={handleUseAnotherAccount}>
          Entrar com outra conta
        </Button>
      </div>
    </LoginCard>
  )
}
